import React from 'react';
import ResponsiveImage from '../../01-atoms/images/ResponsiveImage/ResponsiveImage.component';
import { imageTypeProps } from '../../01-atoms/images/Image/Image.component';
import Paragraph from '../../01-atoms/text/Paragraph.component';
import bem from '../../_utils/bem';
var blockName = 'text-with-image';

var TextWithImage = function TextWithImage(_ref) {
  var modifiers = _ref.modifiers,
      content = _ref.content,
      image = _ref.image,
      outputImage = _ref.outputImage,
      sources = _ref.sources;
  return /*#__PURE__*/React.createElement("div", {
    className: bem(blockName, null, modifiers)
  }, /*#__PURE__*/React.createElement("div", {
    className: bem(blockName, 'image')
  }, /*#__PURE__*/React.createElement(ResponsiveImage, {
    outputImage: outputImage,
    sources: sources,
    image: image
  })), /*#__PURE__*/React.createElement("div", {
    className: bem(blockName, 'text')
  }, /*#__PURE__*/React.createElement(Paragraph, null, content)));
};

export default TextWithImage;